export default __webpack_public_path__ + "static/media/bank.e41efc4d.jpg";